import { $, $$ } from '@/utilities/helpers';
import Swal from 'sweetalert2/dist/sweetalert2.js'

const Toast = Swal.mixin({
    toast: true,
    position: 'bottom-right',
    iconColor: 'white',
    customClass: {
        popup: 'colored-toast',
    },
    showConfirmButton: false,
    timer: 3000,
    timerProgressBar: true,
})

let $requestModalToggle = $('.js-feature-request-form-toggle');
let $requestModal = $('.js-feature-request-form-modal');

if ($requestModalToggle && $requestModal) {
    $requestModalToggle.addEventListener('click', (e) => {
        e.preventDefault();

        document.body.classList.toggle('notificationActiveInvisible');
        $requestModal.classList.toggle('visible');
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
            document.body.classList.remove('notificationActiveInvisible');
            $requestModal.classList.remove('visible');
        }
    });

    document.addEventListener('click', (e) => {
        if (e.target === $requestModal && !e.target.closest('.feature-request-modal__wrap')) {
            document.body.classList.remove('notificationActiveInvisible');
            $requestModal.classList.remove('visible');
        }
    });



    if ($('.dashboard')) {

        /*------------------------------------------------------------------
        Signup form
        ------------------------------------------------------------------*/
        let $requestFeatureForm = $('#Form_FeatureRequestForm');


        $requestFeatureForm.addEventListener('submit', (e) => {
            e.preventDefault();
            console.log('form submitted');


            // Send the form data to the server
            fetch(`${$requestFeatureForm.dataset.apiUrl}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    Title: $requestFeatureForm.querySelector('#Form_FeatureRequestForm_Title').value,
                    Content: $requestFeatureForm.querySelector('#Form_FeatureRequestForm_Content').value,
                }),
            })
                .then(response => response.json())
                .then(data => {
                    Toast.fire({
                        icon: (data.message === 'Feature request submitted') ? 'success' : 'error',
                        title: data.message,
                    });
                    document.body.classList.remove('notificationActiveInvisible');
                    $requestModal.classList.remove('visible');
                })

        });
    }

}



let $$hearts = $$('.js-toggle-item-from-wishlist');

if ($$hearts) {
    $$hearts.forEach($heart => {
        $heart.addEventListener('click', (e) => {
            e.preventDefault();

            $heart.classList.toggle('hearted');

            fetch($heart.dataset.apiUrl, {
                method: 'POST',
            }).then(response => response.json())
                .then(data => {
                    if (data.status === 'ok') {
                        $heart.querySelector('.js-heart-count').textContent = data.data.votes;
                    } else {
                        $heart.classList.toggle('hearted');
                    }

                    Toast.fire({
                        icon: (data.status === 'ok') ? 'success' : 'error',
                        title: data.message
                    });
                });
        });
    });
}
